<div attr.name="CellSession_{{ item.name }}" class="tCol clickCol desktop" id="CellSession_{{ item.id }}">
    <!-- for some reason using [ngClass] does not seem to want to work here -->
    <span *ngIf="item.sessionIdentityId != null && item.sessionActive" class="icon-NFAuthConnected"></span>
    <span *ngIf="item.sessionIdentityId != null && !item.sessionActive" class="icon-NFAuthDisconnected"></span>
</div>
